import { DLFormStartEvent } from "../DLEvents"

const handleClickForm = () => {
  DLFormStartEvent({ placement: "main" })
}

export { handleClickForm }
